import ProWelcome from './ProWelcome';

export default ProWelcome;
